<template>
  <div id="app">
    <div v-if="showHeader">

      <div id="header_menu">
        <HeaderMenu/>
      </div>
      <div id="monitor_content">
        <router-view/>
      </div>
    </div>

    <div v-else>
      <div id="mobile_content">
        <router-view/>
      </div>
    </div>

  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useRouter } from 'vue-router'
import HeaderMenu from '@/views/app/HeaderMenu.vue'
import isSmartPhone from '@/js/isSmartPhone.js'

export default defineComponent({
  components: {
    HeaderMenu
  },
  setup () {
    const router = useRouter()

    const showHeader = computed(() => {
      // console.log(router.currentRoute.value.meta.headerShow)
      // console.log(router.currentRoute)
      return !isSmartPhone() && router.currentRoute.value.meta.headerShow
    })

    return {
      showHeader
    }
  }
})
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  #header_menu {
    position: fixed;
    width: 100vw;
    height: 5vh;
    top: 0;
    border-bottom: 1px solid black;
    z-index: 2;
  }
  #monitor_content {
    position: fixed;
    width: 100vw;
    height: 95vh;
    bottom: 0;
    z-index: 1;
  }
  #mobile_content {
    position: fixed;
    width: 100vw;
    height: 100vh;
  }
}

</style>
